import React, { useState, useEffect } from 'react';

function EditableInput ({ name, value, index, onValueChange, path, contentStyle, editStyle, editable}) {
    
    const [edit, setEdit] = useState(false);
    const [text, setText] = useState(value);

    useEffect(() => {
      if (edit) {
        document.getElementById(`${name}-${index}`).focus();
      }
    }, [edit, name, index]);

    const handleContentClick = (index, content) => {
      if (!editable) return;
      setEdit(true);
      setText(content);
    };

    function handleChange(event) {
      setText(event.target.value);
    }

    const handleEditableBlur = (event, index) => {
      setEdit(false);
      setText(event.target.value);
      if (onValueChange) onValueChange(path, event.target.value);
    };

    const handleKeyPress = (event, index) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        handleEditableBlur(event, index);
      }
    }

    return (
      ((edit && editable) ? (
        <input 
          id={`${name}-${index}`}
          key={`${name}-${index}`}
          type="text" 
          value={text} 
          onChange={handleChange} 
          onBlur={(e) => handleEditableBlur(e, index)}
          onKeyPress={(e) => handleKeyPress(e, index)}
          style={{...editStyle}}
        />
      ) : (
        <div style={{cursor: editable ? "context-menu" : ""}} id={`editable-${name}-${index}`} onClick={() => handleContentClick(index, text)}>{text}</div>
      ))
    );
}

export default EditableInput;